import React, { useState } from 'react';
import Validator from 'validatorjs';

import { Field, Form } from 'react-final-form';
import { CheckboxField, SelectField, TextField, CheckboxesField, LocationsField } from '/components/forms/fields';

import { ValidationService } from '/services';

const purposeOptions = [
    {"label":"te koop","value":"te koop"},
    {"label":"te huur","value":"te huur"},
];

const categoryOptions = [
    {"label":"appartement","value":"appartement"},
    {"label":"grond","value":"grond"},
    {"label":"kantoor","value":"kantoor"},
    {"label":"commercieel","value":"commercieel"},
    {"label":"industrieel","value":"industrieel"},
    {"label":"garage / parking","value":"garage / parking"},
    {"label":"huis","value":"huis"},
];

const namePrefixOptions = [
    {"label":"Meneer","value":"Meneer"},
    {"label":"Mevrouw","value":"Mevrouw"},
    {"label":"Juffrouw","value":"Juffrouw"},
    {"label":"Meneer en mevrouw","value":"Meneer en mevrouw"},
];

const extraOptions = [
    {"label":"Tuin","value":"Tuin"},
    {"label":"Garage","value":"Garage"},
];

const EstimateForm = () => {
    const [error, setError] = useState(null);

    const validate = (values) => {
        const rules = {
            firstName: 'required',
            lastName: 'required',
            purpose: 'required',
            category: 'required',
            mobile: 'required',
            email: 'required',
            locations: 'required',
            privacy: 'required',
            bedrooms: 'required',
            namePrefix: 'required',
        };

        const names = {
            firstName: 'voornaam',
            lastName: 'achternaam',
            purpose: 'type transactie',
            category: 'type vastgoed',
            mobile: 'telefoon',
            email: 'e-mailadres',
            locations: 'postcode',
            bedrooms: 'aantal slaapkamers',
            namePrefix: 'aanspreking',
        };

        return ValidationService.validate(values, rules, names);
    };

    const submit = async (values) => {
        const body = new FormData();
        body.append(window.csrfTokenName, window.csrfTokenValue);
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('mobile', values.mobile);
        body.append('email', values.email);

        body.append('locations', values.locations.map(xxx => xxx.postalCode).join(','));

        body.append('purpose', values.purpose && values.purpose.value);
        body.append('category', values.category && values.category.value);

        body.append('bedrooms', values.bedrooms);
        body.append('constructionYear', values.constructionYear);
        body.append('namePrefix', values.namePrefix.value);
        if (values.extraOptions)
            body.append('extraOptions', values.extraOptions);

        try {
            const response = await fetch('${window.siteUrl}/index.php?p=actions/immodule/form/estimate', {
                method: 'post',
                body,
            });

            const bodyFromResponse = await response.json();

            if (bodyFromResponse.success) {
                window.location = window.successRedirect;
            } else {
                window.location = window.failureRedirect;
            }
        } catch {
            window.location = window.failureRedirect;
        }
    };

    const render = ({ handleSubmit }) => (
        <>
        { error && (
            <p className="estimate-form__error">{ error }</p>
        )}
        <form className="estimate-form" onSubmit={handleSubmit}>

            <div className="estimate-form__row">
                <div className="estimate-form__col estimate-form__col--left">
                    <h2 className="estimate-form__title headline-3 font-supplementary--medium">
                        Informatie over uw woning
                    </h2>
                    <Field
                        name="purpose"
                        component={SelectField}
                        label="Type transactie"
                        placeholder="Type transactie *"
                        options={purposeOptions}
                        required
                    />
                    <Field
                        name="category"
                        component={SelectField}
                        label="Type vastgoed"
                        placeholder="Type vastgoed *"
                        options={categoryOptions}
                        required
                    />
                    <Field
                        name="locations"
                        component={LocationsField}
                        label="Postcode of gemeente"
                        placeholder="Postcode of gemeente *"
                        required
                    />
                    <Field
                        name="bedrooms"
                        component={TextField}
                        label="Aantal slaapkamers"
                        placeholder="Aantal slaapkamers *"
                        type="number"
                        required
                    />
                    <Field
                        name="constructionYear"
                        component={TextField}
                        label="Bouwjaar"
                        placeholder="Bouwjaar"
                        type="text"
                    />

                    <div className="estimate-form__options">
                        <Field
                            name="extraOptions"
                            component={CheckboxesField}
                            label="Opties"
                            options={extraOptions}
                            type="checkbox"
                        />
                    </div>
                </div>
                <div className="estimate-form__col estimate-form__col--right">
                    <h2 className="estimate-form__title headline-3 font-supplementary--medium">
                        Uw gegevens
                    </h2>

                    <Field
                        name="namePrefix"
                        component={SelectField}
                        label="Aanspreking"
                        placeholder="Aanspreking *"
                        options={namePrefixOptions}
                        required
                    />
                    <Field
                        name="firstName"
                        component={TextField}
                        label="Voornaam"
                        placeholder="Voornaam *"
                        type="text"
                        required
                    />
                    <Field
                        name="lastName"
                        component={TextField}
                        label="Naam"
                        placeholder="Naam *"
                        type="text"
                        required
                    />
                    <Field
                        name="email"
                        component={TextField}
                        label="E-mailadres"
                        placeholder="E-mailadres *"
                        type="email"
                        required
                    />
                    <Field
                        name="mobile"
                        component={TextField}
                        label="Telefoonnummer"
                        placeholder="Telefoonnummer *"
                        type="tel"
                        required
                    />
                </div>
            </div>

            <div className="estimate-form__actions">
                <div className="estimate-form__actions-item estimate-form__actions-item__left">
                    <Field
                        name="privacy"
                        component={CheckboxField}
                        label={window.privacyMessage}
                        type="checkbox"
                        required
                    />
                </div>
                <div className="estimate-form__actions-item estimate-form__actions-item__right">
                    <button className="button" type="submit">
                        Verzenden
                    </button>
                </div>
            </div>
        </form>
        </>
    );

    return (
        <Form
            validate={validate}
            onSubmit={submit}
            render={render}
        />
    );
};

export { EstimateForm };
